<template>
    <rkm-overlay>
        <rkm-layout-body title="Procedimentos">
            <template v-slot:actions>

                <rkm-button
                    @click="$router.push({ name: 'atencao-basica-procedimento-create' })"
                    autorize="store-atencao-basica-procedimento"
                    color="primary"
                >
                    Cadastrar atendimento
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/atencao-basica/procedimento/List'

export default {
    components: { List },
}
</script>